/**
 * Управление навигацией страницы, работа с hash параметрами страницы
 * @packageDocumentation
 */

/**
 * Получить значение хэш параметра страницы
 */
export const getHash = function (name: string, locationHash: string = location.hash): string {
	const re = new RegExp('[#?&]' + name + '=([^&]*)');
	const value = locationHash.match(re);
	if (!value || value.length != 2) return '';

	value[1] = decodeURIComponent(value[1]);
	value[1] = value[1].replace(/\+/g, ' ');

	return value[1];
};

/**
 * Установить значение в хэш параметр страницы
 */
export const setHash = function (name: string, value: string | number | null, replaceState: boolean = true): void {
	let hash = genHash(name, value);

	if (replaceState) {
		historySetState(true, hash);
	} else {
		historySetState(false, hash);
	}
};

/**
 * Удалить значение из хэш параметра страницы
 */
export const delHash = function (name: string, value: string, replaceState: boolean = true): void {
	setHash(name, null, replaceState);
};

/**
 * Сгенерировать новое значение для хэш параметра страницы с указанным параметром
 */
export const genHash = function (name: string, value: string | number | null, locationHash: string = location.hash): string {
	const re = new RegExp('&?' + name + '=[^&]*', 'g');

	locationHash = locationHash.replace(re, '');

	if (value !== null) {
		value = (value + '').replace(' ', '%20');
		locationHash = locationHash.replace(re, '&' + name + '=' + value);

		if (locationHash.indexOf('&' + name + '=') == -1) locationHash += '&' + name + '=' + value;
	}

	locationHash = locationHash.replace(/&+/g, '&');
	locationHash = locationHash.replace(/^(#)?&|&$/g, '$1');

	locationHash = '#' + locationHash;
	locationHash = locationHash.replace(/^#+/, '#');

	if (locationHash === '#') locationHash = '';

	return locationHash;
};

/**
 * Установить значения в хэш параметр страницы
 */
export const setHashs = function (data: Map<string, string> | object | any, replaceState: boolean): void {
	if (data instanceof Map) data = Object.fromEntries(data);

	if (replaceState === undefined) replaceState = true;
	let hash = location.hash;

	for (const name in data) {
		const re = new RegExp('&?' + name + '=[^&]*', 'g');
		hash = hash.replace(re, '');

		if (data[name] !== null) {
			data[name] = (data[name] + '').replace(' ', '%20');
			hash += '&' + name + '=' + data[name];
		}
	}

	hash = hash.replace(/&+/g, '&');
	hash = hash.replace(/^(#)?&|&$/g, '$1');

	hash = '#' + hash;
	hash = hash.replace(/^#+/, '#');

	if (hash === '#') hash = '';

	if (replaceState) {
		historySetState(true, hash);
	} else {
		historySetState(false, hash);
	}
};

/**
 * Установть позицию в истории вкладки браузера
 *
 * @see history.replaceState
 * @see history.pushState
 *
 * @todo Объединить с historyPushState() из @/component/vue/app/spa
 */
export const historySetState = (replace: boolean = false, hash: string): void => {
	// дедупликация хеш навигации
	// необходима так как js слушает нативную навигацию и если состояние уже устанолено, оно не должно повторно устанавливаться из js
	if (hash === location.hash) return;

	const oldURL = location.href;

	const url = location.href.replace(/#.*/, '') + hash;

	if (replace) {
		history.replaceState(history.state, '', url);
	} else {
		history.pushState(history.state, '', url);
	}

	// имитация hashchange, так как при работе с history, он не будет вызван автоматически
	const event = new HashChangeEvent('hashchange', {
		oldURL: oldURL,
		newURL: url,
	});

	window.dispatchEvent(event);
};
